<script setup lang="ts">
import MessageList from '@/components/assistant/chat/MessageList.vue'
import type {CreditUsage} from '@/client/mentor/CreditUsageClient'
import type {Message} from '@/client/mentor/MessagesClient'
import {computed} from 'vue'
import {useI18n} from 'vue-i18n'

interface DescriptionItem {
  description: string
  iconClasses: string
}

defineProps<{
  companyId: number
  creditUsage?: CreditUsage
  hasCreditsLeft: boolean
  pendingMessages?: Message[]
}>()

const {t} = useI18n()

const descriptionItems = computed<DescriptionItem[]>(() => [
  {
    iconClasses: 'fa-solid fa-circle-nodes',
    description: t('assistant.chat.emptyState.descriptions.first'),
  },
  {
    iconClasses: 'fa-solid fa-clipboard-check',
    description: t('assistant.chat.emptyState.descriptions.second'),
  },
  {
    iconClasses: 'fa-solid fa-chart-simple',
    description: t('assistant.chat.emptyState.descriptions.third'),
  },
  {
    iconClasses: 'fa-solid fa-comment',
    description: t('assistant.chat.emptyState.descriptions.fourth'),
  },
])
</script>

<template>
  <MessageList
    v-if="pendingMessages && pendingMessages.length > 0"
    :company-id="companyId"
    :credit-usage="creditUsage"
    :disabled="!hasCreditsLeft"
    :messages="pendingMessages"
  />

  <div v-else class="w-full h-full overflow-y-auto flex flex-col items-center justify-center">
    <div
      class="w-[80%] max-w-[600px] p-4 bg-new-neutral-50 rounded-lg grid grid-cols-[max-content_1fr] items-center gap-x-4 gap-y-2"
    >
      <template v-for="(item, index) in descriptionItems" :key="index">
        <div
          class="w-6 h-6 rounded-md transition-colors duration-200 flex items-center justify-center text-white text-xs bg-new-neutral-400 hover:bg-new-neutral-600"
        >
          <i :class="item.iconClasses"></i>
        </div>

        <span>{{ item.description }}</span>
      </template>
    </div>
  </div>
</template>
